module.exports = __webpack_public_path__ + "static/img/5.63abba9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/winter/dice/5.png
// module id = 1NJ4
// module chunks = 2